import { execSQL, esc, num } from './api';

const TABLE = 'dbo.payroll_loan';
const SP    = 'dbo.payroll_loan_sp';

// The loan type says which payslip deduction line its installments belong on,
// so it travels with the loan rather than being guessed from the type's name.
// Named the way the payslip names people, and in EPF number order.
export const fetchLoans = () =>
  execSQL(
    `SELECT l.*, lt.linkedComponent, lt.installmentMethod, ` +
    `LTRIM(RTRIM(ISNULL(e.initial,'') + ISNULL(e.initials,'') + ' ' + ISNULL(e.surName,''))) AS empName ` +
    `FROM ${TABLE} l ` +
    `LEFT JOIN dbo.payroll_loan_type lt ON lt.id = l.loanTypeId ` +
    `LEFT JOIN dbo.payroll_employee e ON e.emp_id = l.emp_id ` +
    `ORDER BY CAST(l.emp_id AS INT), l.id`
  );

/* What a loan takes in one payroll month. The monthly figure is rounded down
 * and the last installment takes whatever is left, so exactly the amount payable
 * is recovered: 22,940 over 12 is eleven of 1,911 and a final 1,919, where
 * rounding to the nearest took 1,912 twelve times - 22,944.
 * Counted from the start date, so a loan takes nothing before it starts and
 * stops on its own after the last installment. */
export const installmentFor = (loan, runMonth) => {
  const monthly = Number(loan.monthlyInstallment || 0);
  const count   = Number(loan.installments || 0);
  const start   = /^(\d{4})-(\d{2})/.exec(String(loan.startDate || ""));
  const run     = /^(\d{4})-(\d{2})/.exec(String(runMonth || ""));
  if (!start || !run || count <= 0) return monthly;   // nothing to count from
  const n = (run[1] - start[1]) * 12 + (run[2] - start[2]) + 1;   // 1 = the start month
  if (n < 1 || n > count) return 0;
  if (n < count) return monthly;
  return Math.max(0, Number(loan.totalPayable || 0) - monthly * (count - 1));
};

export const createLoan = (d) =>
  execSQL(
    `EXEC ${SP} @action='INSERT',@emp_id=${esc(d.emp_id)},@loanTypeId=${num(d.loanTypeId)},` +
    `@loanType=${esc(d.loanType)},@principal=${num(d.principal)},@interestRate=${num(d.interestRate)},` +
    `@totalPayable=${num(d.totalPayable)},@installments=${num(d.installments)},` +
    `@monthlyInstallment=${num(d.monthlyInstallment)},@remaining=${num(d.totalPayable)},` +
    `@startDate=${esc(d.startDate)}`
  );

// Editing a live loan: the employee is fixed (change that and it is a different
// loan), but every figure can move - a resignation settles the balance early.
export const updateLoan = (id, d) =>
  execSQL(
    `EXEC ${SP} @action='UPDATE',@id=${num(id)},@loanTypeId=${num(d.loanTypeId)},` +
    `@loanType=${esc(d.loanType)},@principal=${num(d.principal)},@interestRate=${num(d.interestRate)},` +
    `@totalPayable=${num(d.totalPayable)},@installments=${num(d.installments)},` +
    `@monthlyInstallment=${num(d.monthlyInstallment)},@remaining=${num(d.remaining)},` +
    `@startDate=${esc(d.startDate)}`
  );

export const closeLoan = (id) =>
  execSQL(`EXEC ${SP} @action='CLOSE',@id=${id}`);
